module.exports = __webpack_public_path__ + "img/px.fbfae33f.png";